// Auth
export const LOG_OUT = 'LOG_OUT';
export const SET_CURRENT_TABLE_DATA = 'SET_CURRENT_TABLE_DATA';
export const SET_KEYCLOAK_AUTHENTICATED = 'SET_KEYCLOAK_AUTHENTICATED';
export const SET_KEYCLOAK_READY = 'SET_KEYCLOAK_READY';
export const SET_ORDERS_RETRIEVED = 'SET_ORDERS_RETRIEVED';
export const SET_KEYCLOAK_TOKENS = 'SET_KEYCLOAK_TOKENS';
export const SET_TOKENS = 'SET_TOKENS';
export const SET_URLS = 'SET_URLS';
